import { useParams } from "react-router";
import { ContactPropertyView } from "./property-view";

export default function ContactPropertyPage() {
  const { propertyId = "" } = useParams<{ propertyId: string }>();
  return <ContactPropertyView key={propertyId} propertyId={propertyId} />;
}
